import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, branch, renderComponent } from 'recompose'
import { push } from 'connected-react-router'

import * as actions from 'modules/user/actions'
import * as selectors from 'modules/user/selectors'
import { page, track } from 'utils/trackingUtils'

import { PasswordStep, AEPasswordStep, BasicPasswordStep } from './component'

const mapStateToProps = state => ({
  flow: selectors.getFlow(state),
  password: selectors.getPassword(state),
  isRepInvitedFlow: selectors.isRepInvitedFlow(state),
  passwordConfig: selectors.passwordConfig(state),
  passwordConfigFetched: selectors.passwordConfigFetched(state),
  passwordUpdateStatus: selectors.passwordUpdateStatus(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setPassword: actions.setPassword,
    updatePassword: actions.updatePassword,
    push,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Password Setup', {
        flow: this.props.flow,
        context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
      })
    },
    componentDidUpdate(prevProps, prevState) {
      if (this.props.passwordUpdateStatus && this.props.passwordUpdateStatus === 'success') {
        // redirect!
        track('Onboarding Password Setup Completed', {
          flow: this.props.flow,
          context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
        })

        if (this.props.isCalendarSeat) {
          this.props.actions.push(`/setup/calendaring/profile`)
        } else if (window.location.pathname.includes("reporting")) {
          this.props.actions.push(`/setup/enterprise/profile/reporting`)
        } else if (window.location.pathname.includes("playbooks")) {
          this.props.actions.push(`/setup/enterprise/profile/playbooks`)
        } else {
          // the invited rep flow vs invited unified seat flow difference is handled by the user epic
          // since we're dependent on knowing the user's gates/role

          // for video and hyfy migration flows, we let the user epic handle redirecting to drift video
          // based on the "flow"
        }
      }
    }
  }),
  withHandlers({
    onPasswordChange: props => event => {
      props.actions.setPassword(event.target.value)
    },
    onContinueClick: props => () => {
      props.actions.updatePassword()
    }
  }),
  branch(props => props.isEnterpriseSeat, renderComponent(BasicPasswordStep)),
  branch(props => props.isCalendarSeat, renderComponent(AEPasswordStep)),
)(PasswordStep)
